import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import cloneDeep from 'lodash/cloneDeep';
import {
  Col,
  Grid,
  Panel,
  Button,
  Breadcrumb,
  ButtonToolbar,
} from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import { Translate, I18n } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';

import Spinner from '../Widgets/spinner';
import CashFormatter from '../Common/cashFormatter';
import ContentWrapper from '../Layout/ContentWrapper';
import ConfirmActionModal from '../Common/confirmActionModal';
import { numberWithCommas } from '../Common/numberWithCommas';
import GenericDatePicker from '../Common/GenericDatePicker';
import SpinnerButton from '../Common/SpinnerButton';
import {
  fetchDrivers,
  saveDeliveryFees,
  fetchDriverCodes,
  fetchDeliveryFee,
  sendDriverInvite,
} from '../../actions/dispatch_actions';

const propTypes = {
  value: PropTypes.node,
  checkPermissionSuccess: PropTypes.boolean,
  checkPermission: PropTypes.func,
};

const defaultProps = {
  value: null,
  checkPermissionSuccess: false,
  checkPermission: () => {},
};


class Drivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingDrivers: false,
      isLoadingSendInvite: false,
      isLoadingDeliveryHistory: false,
      isLoadingSaveDeliveryFees: false,
      isInviteModalOpen: false,
      isPermissionModalOpen: false,
      isDeliveryFeeModalOpen: false,
      isExternal: false,
      email: '',
      driversList: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      deliveryHistory: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      internalCode: undefined,
      externalCode: undefined,
      selectedDriverIdx: null,
      totalDriverFee: 0,
      totalTruckxiFee: 0,
      totalDeliveryFee: 0,
      driverFeeRate: 0,
      truckxiFeeRate: 0,
      startDate: undefined,
      endDate: undefined,
    };
  }

  componentDidMount() {
    this.handleFetchDrivers();
    this.handleFetchDriverCodes();
    this.handleFetchDeliveryFee();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deliveryHistory !== this.state.deliveryHistory) {
      let totalDriverFee = 0;
      let totalTruckxiFee = 0;
      let totalDeliveryFee = 0;
      map(this.state.deliveryHistory.rows, (row) => {
        totalDriverFee += row.driverFee;
        totalTruckxiFee += row.truckxiFee;
        totalDeliveryFee += row.totalDeliveryFee;
      });
      this.setState({
        totalDriverFee,
        totalTruckxiFee,
        totalDeliveryFee,
      });
    }

    if (this.props.checkPermissionSuccess && prevProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
      if (this.props.checkPermissionSuccess.manager) {
        this.closePermissionModal();
        this.openDeliveryFeeModal();
      }
    }
  }

  setStartDate = (e) => {
    if (this.state.startDateSelected && e < this.state.startDateSelected) {
      alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
      return;
    }
    this.setState({ startDate: e }, () => {
      const { endDate } = this.state;
      this.handleFetchDrivers(e, endDate);
    });
  }

  setEndDate = (e) => {
    if (this.state.endDateSelected && e > this.state.endDateSelected) {
      alert(I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
      return;
    }
    this.setState({ endDate: e }, () => {
      const { startDate } = this.state;
      this.handleFetchDrivers(startDate, e);
    });
  }

  openPermissionModal = () => {
    this.setState({ isPermissionModalOpen: true });
  }

  closePermissionModal = () => {
    this.setState({ isPermissionModalOpen: false });
  }

  openDeliveryFeeModal = () => {
    this.setState({ isDeliveryFeeModalOpen: true });
  }

  closeDeliveryFeeModal = () => {
    this.setState({ isDeliveryFeeModalOpen: false });
  }

  openInviteModal = () => {
    this.setState({ isInviteModalOpen: true });
  }

  closeInviteModal = () => {
    this.setState({ isInviteModalOpen: false });
  }

  handleFetchDrivers = (startDate, endDate) => {
    const handleSuccess = (drivers) => {
      const { selectedDriverIdx } = this.state;
      let deliveryHistoryRows;
      let deliveryHistory = cloneDeep(this.state.deliveryHistory);
      if (selectedDriverIdx !== null) {
        map(drivers, (row, index) => {
          if (index === selectedDriverIdx) {
            deliveryHistoryRows = row.salesOrders;
            row.isSelected = true;
          }
        });
      }
      deliveryHistory = {
        ...this.state.deliveryHistory,
        rows: deliveryHistoryRows,
      };
      const driversList = { ...this.state.driversList, rows: drivers };
      this.setState({
        driversList,
        deliveryHistory,
        isLoadingDrivers: false,
      });
    };
    const handleFailure = () => {
      this.setState({ isLoadingDrivers: false });
    };
    this.setState({ isLoadingDrivers: true }, () => {
      fetchDrivers(startDate, endDate, handleSuccess, handleFailure);
    });
  }

  handleFetchDriverCodes = () => {
    const handleSuccess = ({ internalCode, externalCode }) => {
      this.setState({
        internalCode,
        externalCode,
      });
    };
    fetchDriverCodes(handleSuccess, () => {});
  }

  handleFetchDeliveryFee = () => {
    const handleSuccess = (response) => {
      map(response, (data) => {
        const { driverFeeRate, truckxiFeeRate } = data;
        this.setState({
          driverFeeRate,
          truckxiFeeRate,
        });
      });
    };
    fetchDeliveryFee(handleSuccess, () => {});
  }

  handleSaveDeliveryFees = () => {
    const handleSuccess = () => {
      this.setState({ isLoadingSaveDeliveryFees: false }, () => {
        this.closeDeliveryFeeModal();
      });
    };
    const handleFailure = (error) => {
      this.setState({ isLoadingSaveDeliveryFees: false });
      alert(JSON.stringify(error.data.message));
    };
    const { driverFeeRate, truckxiFeeRate } = this.state;
    this.setState({ isLoadingSaveDeliveryFees: true }, () => {
      saveDeliveryFees(driverFeeRate, truckxiFeeRate, handleSuccess, handleFailure);
    });
  }

  handleSendDriverInvite = () => {
    const { email, isExternal } = this.state;
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(I18n.t('please_enter_a_valid_email'));
      return;
    }
    const handleSuccess = () => {
      this.setState({
        email: '',
        isLoadingSendInvite: false,
      });
      this.closeInviteModal();
    };
    const handleFailure = (error) => {
      this.setState({ isLoadingSendInvite: false });
      alert(JSON.stringify(error.data.message));
    };
    this.setState({ isLoadingSendInvite: true }, () => {
      sendDriverInvite(email, isExternal, handleSuccess, handleFailure);
    });
  }

  renderDrivers = () => {
    if (this.state.isLoadingDrivers) {
      return <Spinner />;
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.driversList);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const driversList = { ...this.state.driversList, sortColumn, sortDirection };
      this.setState({ driversList });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let deliveryHistoryRows;
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        deliveryHistoryRows = newRows[r.rowIdx].salesOrders;
        newRows[r.rowIdx].isSelected = true;
      });
      const driversList = {
        ...this.state.driversList,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      const deliveryHistory = {
        ...this.state.deliveryHistory,
        rows: deliveryHistoryRows,
      };
      this.setState({
        driversList,
        deliveryHistory,
        selectedDriverIdx: rows[0].rowIdx,
      });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.driversList.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const driversList = { ...this.state.driversList, filters: newFilters };
      this.setState({ driversList });
    };

    const onClearFilters = () => {
      const driversList = { ...this.state.driversList, filters: {} };
      this.setState({ driversList });
    };

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'email',
        name: <Translate value="email" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Col sm={12}>
        <div id="Drivers-dataGrid1">
          <ReactDataGrid
            rowKey="name"
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={25}
            rowGetter={rowGetter}
            toolbar={<Toolbar enableFilter />}
            onClearFilters={onClearFilters}
            onAddFilter={handleFilterChange}
            rowsCount={getSize()}
            minHeight={530}
            enableRowSelect="single"
            rowSelection={{
              showCheckbox: true,
              onRowsSelected,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            }}
          />
        </div>
      </Col>
    );
  }

  renderDeliveryHistory = () => {
    if (this.state.isLoadingDeliveryHistory) {
      return <Spinner />;
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.deliveryHistory);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const deliveryHistory = {
        ...this.state.deliveryHistory,
        sortColumn,
        sortDirection,
      };
      this.setState({ deliveryHistory });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.deliveryHistory.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const deliveryHistory = { ...this.state.deliveryHistory, filters: newFilters };
      this.setState({ deliveryHistory });
    };

    const onClearFilters = () => {
      const deliveryHistory = { ...this.state.deliveryHistory, filters: {} };
      this.setState({ deliveryHistory });
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const columns = [
      {
        key: 'soNum',
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'shipmentDate',
        name: <Translate value="shipment_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'driverFee',
        name: <Translate value="driver_fee" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'truckxiFee',
        name: <Translate value="truckxi_fee" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'totalDeliveryFee',
        name: <Translate value="total_delivery_fee" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
    ];
    return (
      <Col sm={12}>
        <div id="DeliveryHistory-dataGrid1">
          <ReactDataGrid
            rowKey="soNum"
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={25}
            rowGetter={rowGetter}
            toolbar={<Toolbar enableFilter />}
            onClearFilters={onClearFilters}
            onAddFilter={handleFilterChange}
            rowsCount={getSize()}
            minHeight={540}
          />
        </div>
      </Col>
    );
  }

  renderDriverInvite = () => (
    <div className="invite-drivers-section">
      <div className="invite-label-area">
        <div className="code-section">
          <div className="invite-label">
            <Translate value="internal" />:&nbsp;
          </div>
          <div className="invite-code font-color-grey">
            { this.state.internalCode }
          </div>
        </div>
        <div className="code-section">
          <div className="invite-label">
            <Translate value="external" />:&nbsp;
          </div>
          <div className="invite-code font-color-grey">
            { this.state.externalCode }
          </div>
        </div>
      </div>
      <Button
        bsStyle="primary"
        onClick={this.openInviteModal}
      >
        <em className="fa fa-envelope" /><Translate value="send_invite" />
      </Button>
    </div>
  )

  renderInviteModal = () => (
    <div id="driver-invite-modal">
      <div className="invite-type-section">
        <label htmlFor="internal-option">
          <input
            type="checkbox"
            name="internal-list-option"
            checked={!this.state.isExternal}
            onClick={() => {
              this.setState({ isExternal: false });
            }}
          />
          <Translate value="internal" />
        </label>
        <label htmlFor="external-option">
          <input
            type="checkbox"
            name="external-option"
            checked={this.state.isExternal}
            onClick={() => {
              this.setState({ isExternal: true });
            }}
          />
          <Translate value="external" />
        </label>
      </div>
      <div className="invite-email-section">
        <Translate value="enter_email_of_driver" />
        <input
          name="driver-email"
          type="text"
          className="email-input"
          value={this.state.email}
          onChange={(e) => { this.setState({ email: e.target.value }); }}
        />
      </div>
      <SpinnerButton
        bsStyle="primary"
        onClick={this.handleSendDriverInvite}
        loading={this.state.isLoadingSendInvite}
        icon="fa-envelope"
        translation={<Translate value="invite" />}
        disabled={this.state.isLoadingSendInvite}
      />
    </div>
  );

  renderDeliveryFeeModal = () => (
    <div id="delivery-fee-modal">
      <div className="delivery-fee-section">
        <label htmlFor="driver-fee" className="label-input">
          <div>
            <Translate value="driver_fee" />:&nbsp;
          </div>
          <div>
            <input
              type="text"
              name="driver-fee"
              className="fee-input"
              value={this.state.driverFeeRate}
              onChange={(e) => { this.setState({ driverFeeRate: e.target.value }); }}
            />
            <span>%</span>
          </div>
        </label>
        <label htmlFor="truckxi-fee" className="label-input">
          <div>
            <Translate value="truckxi_fee" />:&nbsp;
          </div>
          <div>
            <input
              type="text"
              name="truckxi-fee"
              className="fee-input"
              value={this.state.truckxiFeeRate}
              onChange={(e) => { this.setState({ truckxiFeeRate: e.target.value }); }}
            />
            <span>%</span>
          </div>
        </label>
      </div>
      <SpinnerButton
        bsStyle="success"
        onClick={this.handleSaveDeliveryFees}
        loading={this.state.isLoadingSaveDeliveryFees}
        icon="fa-save"
        translation={<Translate value="save" />}
        disabled={this.state.isLoadingSaveDeliveryFees}
      />
    </div>
  );

  render() {
    const createDialogStyle = {
      width: '450px',
      height: '250px',
      marginLeft: '-10%',
      top: '55%',
    };
    const permissionDialog = {
      width: '650px',
      marginLeft: '-15%',
    };
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="drivers" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          <Button
            bsStyle="primary"
            onClick={this.openPermissionModal}
          >
            <em className="fa fa-dollar" /><Translate value="manage_fees" />
          </Button>
        </ButtonToolbar>
        <Grid id="drivers">
          <Col xs={4}>
            <Panel className="table-panel">
              <h2><Translate value="drivers" /></h2>
              { this.renderDriverInvite() }
              { this.renderDrivers() }
            </Panel>
          </Col>
          <Col xs={8}>
            <Panel className="table-panel">
              <h2><Translate value="orders_delivered" /></h2>
              <div className="date-pickers">
                <div className="label-and-date-picker">
                  <Translate value="from" />:&nbsp;
                  <GenericDatePicker
                    setDate={this.setStartDate}
                    selectedDate={this.state.startDate}
                  />
                </div>
                <div className="label-and-date-picker">
                  <Translate value="to" />:&nbsp;
                  <GenericDatePicker
                    setDate={this.setEndDate}
                    selectedDate={this.state.endDate}
                  />
                </div>
              </div>
              { this.renderDeliveryHistory() }
              <Col xsOffset={3} xs={3} className="delivery-fee-col">
                <span className="total-delivery-fee">
                  <Translate value="total_driver_fee" />:&nbsp;
                </span>
                <span className="font-color-grey">
                  { `$${numberWithCommas(this.state.totalDriverFee.toFixed(2))}` }
                </span>
              </Col>
              <Col xs={3} className="truckxi-fee-col">
                <span className="total-truckxi-fee">
                  <Translate value="total_truckxi_fee" />:&nbsp;
                </span>
                <span className="font-color-grey">
                  { `$${numberWithCommas(this.state.totalTruckxiFee.toFixed(2))}` }
                </span>
              </Col>
              <Col xs={3} className="delivery-fee-col">
                <span className="total-delivery-fee">
                  <Translate value="total_delivery_fee" />:&nbsp;
                </span>
                <span className="font-color-grey">
                  { `$${numberWithCommas(this.state.totalDeliveryFee.toFixed(2))}` }
                </span>
              </Col>
            </Panel>
          </Col>
        </Grid>
        <SkyLightStateless
          dialogStyles={permissionDialog}
          isVisible={this.state.isPermissionModalOpen}
          onCloseClicked={() => { this.closePermissionModal(); }}
          title={<Translate value="permission_to_change_delivery_fees" />}
        >
          <ConfirmActionModal
            case="editDeliveryFeeRate"
            checkPermission={this.props.checkPermission}
            checkPermissionSuccess={this.props.checkPermissionSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.isInviteModalOpen}
          onCloseClicked={this.closeInviteModal}
          title={<Translate value="invite" />}
        >
          { this.renderInviteModal() }
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.isDeliveryFeeModalOpen}
          onCloseClicked={this.closeDeliveryFeeModal}
          title={<Translate value="delivery_fees" />}
        >
          { this.renderDeliveryFeeModal() }
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

Drivers.propTypes = propTypes;
Drivers.defaultProps = defaultProps;

export default Drivers;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/Drivers.jsx